import {FC, useMemo} from 'react'
import {ColumnInstance} from 'react-table'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {Model} from '../../core/_models'
import clsx from 'clsx'

type Props = {
  className?: string
  title?: string
  tableProps: ColumnInstance<Model>
}

const CustomHeader: FC<Props> = ({className, title, tableProps}) => {
  const id = tableProps.id
  const {state, updateState} = useQueryRequest()

  const isSelectedForSorting = useMemo(() => {
    return state.sort && state.sort === id
  }, [state, id])
  const order: 'asc' | 'desc' | undefined = useMemo(() => state.order, [state])

  const sortColumn = () => {
    // avoid sorting for these columns
    if (id === 'actions') {
      return
    }

    if (!isSelectedForSorting) {
      // enable sort asc
      updateState({...state, sort: id, order: 'asc'})
      return
    }

    if (isSelectedForSorting && order !== undefined) {
      if (order === 'asc') {
        // enable sort desc
        updateState({...state, sort: id, order: 'desc'})
        return
      }

      // disable sort
      updateState({...state, sort: undefined, order: undefined})
    }
  }

  return (
    <th
      {...tableProps.getHeaderProps()}
      className={clsx(
        className,
        isSelectedForSorting && order !== undefined && `table-sort-${order} `
      )}
      style={{cursor: 'pointer',borderBottom:"none",padding:"8px"}}
      onClick={sortColumn}
    >
      {title}
    </th>
  )
}

export {CustomHeader}
